import { Button } from "react-bootstrap"
import { useNavigate } from "react-router-dom"

const PaymentIncomplete = () => {
  const navigate = useNavigate()
  const handleClick = () => {
    navigate("/payments")
  }
  return (
    <>
      <h1 className="mb-4 fs-2 fw-semibold">Payment Incomplete</h1>
      <p className="mb-4">
        It looks like your membership payment is still incomplete. <br />
        Please complete your payment to activate your membership!
      </p>
      <Button
        className="mt-2 px-5 rounded-3"
        variant="dark"
        onClick={handleClick}
      >
        Go To Payment
      </Button>
    </>
  )
}

export default PaymentIncomplete